<!-- @format -->

<ng-container *transloco="let t">
  <div class="app-student-attainments">
    <fudis-section [title]="t('PROFILE.ATTAINMENTS')" [classes]="'fudis-mt-lg'" [level]="2">
      <fudis-section-actions>
        <fudis-button
          *ngIf="transcriptPrintingEnabledByUniversity$ | async"
          [label]="t('PROFILE.ATTAINMENT.BTN_PRINT')"
          [variant]="'secondary'"
          [size]="'small'"
          (handleClick)="printAttainments()" />
      </fudis-section-actions>
      <fudis-section-content>
        <div class="col-12 col-md-5 col-lg-3">
          <label class="form-label">{{ t("PROFILE.ATTAINMENT.ATTAINMENT_STATE") }}</label>
          <sis-dropdown-select
            [options]="attainmentOptions$ | async"
            [selection]="selectedDisplay"
            (selectionChange)="onDropdownSelectionChange($event)">
          </sis-dropdown-select>
        </div>
        <ng-container *ngIf="selectedAttainmentNodes$ | async as attainmentNodes; else loading">
          <fudis-section
            [title]="t('PROFILE.ATTAINMENT.COMPILED_' + selectedDisplay)"
            [classes]="'fudis-mt-lg'"
            [level]="3"
            data-cy="student-attainments-compiled-section">
            <fudis-section-content>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.DEGREE_PROGRAMMES')"
                [classes]="'fudis-mt-md'"
                [titleVariant]="'md'"
                [level]="4"
                data-cy="student-attainments-degree-programmes-section">
                <fudis-section-content>
                  <ng-container *ngIf="attainmentNodes.degreeProgrammeAttainmentNodes.length > 0; else noAttainments">
                    <app-student-attainment-node-wrapper
                      *ngFor="let degreeProgrammeNode of attainmentNodes.degreeProgrammeAttainmentNodes"
                      [attainmentNode]="degreeProgrammeNode"
                      [expandableLevel]="5" />
                  </ng-container>
                </fudis-section-content>
              </fudis-section>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.MODULES')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-modules-section">
                <fudis-section-content>
                  <ng-container *ngIf="attainmentNodes.moduleAttainmentNodes.length > 0; else noAttainments">
                    <app-student-attainment-node-wrapper
                      *ngFor="let moduleAttainmentNode of attainmentNodes.moduleAttainmentNodes"
                      [attainmentNode]="moduleAttainmentNode"
                      [expandableLevel]="5" />
                  </ng-container>
                </fudis-section-content>
              </fudis-section>
            </fudis-section-content>
          </fudis-section>
          <fudis-section
            [title]="t('PROFILE.ATTAINMENT.UNATTACHED_' + selectedDisplay)"
            [classes]="'fudis-mt-lg'"
            [level]="3"
            data-cy="student-attainments-unattached-section">
            <fudis-section-content>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.COURSE_UNITS')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-course-units-section">
                <fudis-section-content>
                  <ng-container *ngIf="attainmentNodes.courseUnitAttainmentNodes.length > 0; else noAttainments">
                    <app-student-attainment-node-wrapper
                      *ngFor="let courseUnitAttainmentNode of attainmentNodes.courseUnitAttainmentNodes"
                      [attainmentNode]="courseUnitAttainmentNode"
                      [expandableLevel]="5" />
                  </ng-container>
                </fudis-section-content>
              </fudis-section>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.ASSESSMENT_ITEMS')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-assessment-items-section">
                <fudis-section-content>
                  <ng-container *ngIf="attainmentNodes.assessmentItemAttainmentNodes.length > 0; else noAttainments">
                    <app-student-attainment-node-wrapper
                      *ngFor="let assessmentItemAttainmentNode of attainmentNodes.assessmentItemAttainmentNodes"
                      [attainmentNode]="assessmentItemAttainmentNode"
                      [expandableLevel]="5" />
                  </ng-container>
                </fudis-section-content>
              </fudis-section>
            </fudis-section-content>
          </fudis-section>
        </ng-container>
      </fudis-section-content>
    </fudis-section>

    <ng-template #loading>
      <div aria-busy="true" class="d-flex justify-content-center">
        <sis-small-spinner />
      </div>
    </ng-template>

    <ng-template #noAttainments>
      <fudis-body-text>{{ t("PROFILE.ATTAINMENT.EMPTY") }}</fudis-body-text>
    </ng-template>
  </div>
</ng-container>
